module.exports = __webpack_public_path__ + "static/media/co04.27c5cd42.png";